// ========================================
// Start Sticky cart
// ========================================
class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.button_id = this.dataset.button;
    this.button_original = null;
    this.btn_item = null;
    this.observer = null;
    this.quantity_input = document.querySelector('#product-quantity-input');
    this.sticky_quantity_input = this.querySelector('.form-field-input');
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.button_original = document.querySelector(this.button_id);
    if (!this.button_original) return;
    this.btn_item = this.querySelector('button.button.button-primary');
    if (!this.btn_item) return;
    this.syncQuantity();
    this.btn_item.addEventListener('click', () => {
      if (this.quantity_input && Number(this.quantity_input.value) > 0) {
        this.button_original.click();
      } else if (this.quantity_input) {
        this.quantity_input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        this.quantity_input.focus();
      }
    });
    if(this.sticky_quantity_input) {
      this.sticky_quantity_input.addEventListener('click', () => {
        this.quantity_input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        this.quantity_input.focus();
      });
      this.quantity_input.addEventListener('input', () => {
        this.syncQuantity();
      });
      this.quantity_input.addEventListener('change', () => {
        this.syncQuantity();
      });
    }
    this.createObserver();
  }
  syncQuantity() {
    if (!this.quantity_input || !this.sticky_quantity_input) return;
    this.sticky_quantity_input.value = this.quantity_input.value;
    console.log(this.sticky_quantity_input.value, this.quantity_input.value)
  }
  createObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            this.classList.add('visible');
          } else {
            this.classList.remove('visible');
          }
        });
      },
      {
        root: null,
        threshold: 0
      }
    );
    this.observer.observe(this.button_original);
  }
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
customElements.define('sticky-add-to-cart-custom', StickyAddCart);
// ========================================
// Finish Sticky cart
// ========================================

// ========================================
// Start List rule b2b
// ========================================
class ListRuleB2B extends HTMLElement {
  constructor() {
    super();
    this.variant_id = this.dataset.variantId;
    this.line_price = this.dataset.linePrice;
    this.variant_price = this.dataset.variantPrice;
    this.rules_list = JSON.parse(this.dataset.rules);
  }
  connectedCallback() {
    this.init();
  }
  init() {
    const rules_html = this.rules_list.map(rule => `
      <li style="font-weight:400;">
        Desde ${rule.quantity}: ${rule.money}/ud
      </li>
    `).join('');
    const html_content = `
      <div style="margin-top:12px;padding:10px 12px;background:#f3f8f8;border:1px solid #30656b;border-radius:4px;">
        <div style="font-size:14px;font-weight:700;color:#30656b;margin-bottom:6px;">
          PRECIO B2B:
          <span style="font-size:28px;line-height:1.1;display:inline-block;margin-left:4px;">${this.line_price}</span>
          <span style="font-weight:400;color:#310d00;font-size:14px;">
            (<span>${this.variant_price}</span>/ud)
          </span>
        </div>

        <div style="font-size:13px;color:#310d00;">
          <strong style="color:#30656b;">Rangos:</strong>
          <ul style="margin:6px 0 0;padding-left:18px;">
            ${rules_html}
          </ul>
        </div>
      </div>
    `;
    const shadow = this.attachShadow({ mode: 'closed' });
    shadow.innerHTML = html_content;
  }
}
customElements.define('list-rule-b2b', ListRuleB2B);
// ========================================
// Finish List rule b2b
// ========================================

// ========================================
// Start Slides
// ========================================
function sliderCollectionsThumbs() {
  const $slider = $('.slider-collections-thumbs');
  if (!$slider.length) return;
  const slider = $slider.find('.swiper-container')[0];
  const sliderNext = $slider.find('.slider-next')[0];
  const sliderPrev = $slider.find('.slider-prev')[0];
  const mySlider = new Swiper(slider, {
    slidesPerView: 3,
    spaceBetween: 5,
    navigation: {
      nextEl: sliderNext,
      prevEl: sliderPrev
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 5
      },
      1200: {
        slidesPerView: 7,
        spaceBetween: 20
      }
    }
  });
}
function sliderReviews() {
  const $slider = $('.slider-reviews');
  if (!$slider.length) return;
  const slider = $slider.find('.swiper-container')[0];
  const sliderNext = $slider.find('.slider-next')[0];
  const sliderPrev = $slider.find('.slider-prev')[0];
  const mySlider = new Swiper(slider, {
    slidesPerView: 'auto',
    spaceBetween: 10,
    navigation: {
      nextEl: sliderNext,
      prevEl: sliderPrev
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 55
      }
    }
  });
}
function sliderFeaturedCollection() {
  const $slider = $('.slider-featured-collection');
  if (!$slider.length) return;
  const slider = $slider.find('.swiper-container')[0];
  const sliderNext = $slider.find('.slider-next')[0];
  const sliderPrev = $slider.find('.slider-prev')[0];
  const mySlider = new Swiper(slider, {
    slidesPerView: 'auto',
    navigation: {
      nextEl: sliderNext,
      prevEl: sliderPrev
    }
  });
}
function sliderImages() {
  const $slider = $('.slider-images');
  if (!$slider.length) return;
  const slider = $slider.find('.swiper-container')[0];
  const sliderNext = $slider.find('.slider-next')[0];
  const sliderPrev = $slider.find('.slider-prev')[0];

  const mySlider = new Swiper(slider, {
    slidesPerView: 'auto',
    spaceBetween: 7,
    navigation: {
      nextEl: sliderNext,
      prevEl: sliderPrev
    },
    breakpoints: {
      768: {
        spaceBetween: 13
      }
    }
  });
}
function sliderGallery() {
  const $slider = $('.slider-gallery-thumbs');
  if (!$slider.length) return;
  const $sliderThumbs = $slider.find('.js-slider-gallery');
  const $prev = $slider.find('.slider-prev');
  const $next = $slider.find('.slider-next');
  const slidesCount = $sliderThumbs.find('.slider__slide').length;
  const slidesArrowRightStop = slidesCount - 3;
  if (slidesCount <= 3) {
    $slider.addClass('has-less-slides');
  }
  $sliderThumbs.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if ($(window).width() < 768) {
      if (nextSlide >= slidesArrowRightStop) {
        $next.addClass('is-disabled');
      } else {
        $next.removeClass('is-disabled')
      }
    }
  });
  $sliderThumbs.on('init', function(event, slick){
    $('.product-gallery--navigation').addClass('is-initialized');
  });
  $sliderThumbs.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    focusOnSelect: true,
    vertical: true,
    prevArrow: $prev,
    nextArrow: $next,
    responsive: [
    {
      breakpoint: 767,
      settings: {
        // centerMode: true,
        vertical: false,
        slidesToShow: 1,
        variableWidth: true
      }
    }
  ]
  });
}
function sliderGalleryHome() {
  const $slider = $('.slider-gallery-thumbs-home');
  if (!$slider.length) return;
  const $sliderThumbs = $slider.find('.js-slider-gallery');
  const $prev = $slider.find('.slider-prev');
  const $next = $slider.find('.slider-next');
  const slidesCount = $sliderThumbs.find('.slider__slide').length;
  const slidesArrowRightStop = slidesCount - 3;
  $sliderThumbs.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if (nextSlide >= slidesArrowRightStop) {
      $next.addClass('is-disabled');
    } else {
      $next.removeClass('is-disabled')
    }
  });
  $sliderThumbs.on('init', function(event, slick){
    $('.product-gallery--navigation').addClass('is-initialized');
  });
  $sliderThumbs.slick({
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    focusOnSelect: true,
    slidesToShow: 1,
    variableWidth: true,
    prevArrow: $prev,
    nextArrow: $next,
  });
}
document.addEventListener('DOMContentLoaded', function () {
  sliderCollectionsThumbs();
  sliderReviews();
  sliderFeaturedCollection();
  sliderImages();
  sliderGallery();
  sliderGalleryHome();
});
// ========================================
// Finish Slides
// ========================================

// ========================================
// Start menu button
// ========================================
$('.js-menu-trigger').on('click', function() {
  $(this).toggleClass('is-active');
  $('.menu-default').toggleClass('is-active');
});

$('.js-menu-close').on('click', function() {
  $('.js-menu-trigger').removeClass('is-active');
  $('.menu-default').removeClass('is-active');
});
// ========================================
// Finish menu button
// ========================================

// ========================================
// Start Bold - Recommendations / Quick Shop
// ========================================
document.addEventListener('DOMContentLoaded', () => {
  const recomendationSection = document.querySelector('.product-recommendations');
  if (!recomendationSection) return;
  const newPrice = document.createElement('span');
  function observingRecomendations(){
    const quickShopButtons = document.querySelectorAll('[data-quickshop-slim]');
    quickShopButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const modalWrapper = document.querySelector('.modal-content');
        let modalContentObserver = new MutationObserver(() => {
          const priceSheet = modalWrapper.querySelector('#product_pricing_sheet');
          const quantityInput = modalWrapper.querySelector('#product-quantity-input');
          if(priceSheet) {
            const priceWrapper = modalWrapper.querySelector('.price--main');
            const priceElement = document.querySelector(
              '.modal-content [data-price] .money:last-child'
            );
            const minPrice = modalWrapper
              .querySelector('.product-pricing')
              .getAttribute('data-min-price');
            newPrice.classList.add('money');
            newPrice.innerHTML = Shopify.formatMoney(
              minPrice,
              theme.money_format
            );
            modalContentObserver.disconnect();
            priceWrapper.insertBefore(newPrice, priceElement);
            const qtyButtons = modalWrapper.querySelectorAll('[data-quantity-value]');
            quantityInput.value = qtyButtons[0].getAttribute('data-quantity-value');
            qtyButtons.forEach((btn) => {
              const quantity = btn.getAttribute('data-quantity-value');
              btn.addEventListener('click', () => {
                quantityInput.value = quantity;
              });
            });
          }
        });
        modalContentObserver.observe(modalWrapper, {
          childList: true,
          subtree: true
        });
      });
    });
    const recomendationProductsPrices =
      recomendationSection.querySelectorAll('.pre-money');
    recomendationProductsPrices.forEach((productPrice) => {
      const minPrice =
        productPrice.parentElement
          .parentElement
          .parentElement
          .getAttribute('data-min-price');
      productPrice.innerHTML = Shopify.formatMoney(
        minPrice,
        theme.money_format
      );
      recomendationsObserver.disconnect();
      recomendationsObserver.observe(recomendationSection, {
        childList: true,
        subtree: true
      });
    });
  }
  let recomendationsObserver = new MutationObserver(() => {
    observingRecomendations();
  });
  recomendationsObserver.observe(recomendationSection, {
    childList: true,
    subtree: true
  });
});
// ========================================
// Finish Bold - Recommendations / Quick Shop
// ========================================

// ========================================
// Start Cloud Search Fix
// ========================================
document.addEventListener('DOMContentLoaded', () => {
  const bodyElem = document.querySelector('body');
  if (!bodyElem) return;
  let searchObserver = new MutationObserver(() => {
    const cloudSearchClose = document.querySelector('.cloud-search-mobile__cancel');
    if (cloudSearchClose) {
      searchObserver.disconnect();
      cloudSearchClose.addEventListener('click', () => {
        document.querySelector('.live-search').classList.remove('live-search--takeover');
        document.querySelector('html').classList.remove('cloud-search-mobile-open');
        document.querySelector('.cloud-search-mobile-backdrop').style = 'display: none';
        document.querySelector('.cloud-search-mobile').style = 'display: none';
        bodyElem.classList.remove('scroll-lock');
      });
      const liveSearchBtn = document.querySelector('.live-search-button--mobile');
      liveSearchBtn.addEventListener('click', () => {
        document.querySelector('html').classList.add('cloud-search-mobile-open');
        document.querySelector('.instant-search-menu--mobile').classList.add('instant-search-menu--mobile-input');
        document.querySelector('.cloud-search-mobile-backdrop').style = 'display: block';
        document.querySelector('.cloud-search-mobile').style = 'display: flex';
      });
    }
  });
  searchObserver.observe(bodyElem, {
    childList: true,
    subtree: true
  });
});
// ========================================
// Finish Cloud Search Fix
// ========================================

/* Handle max min amount JS START */
/*const handleMinMaxQuantity = (function () {
  function disableBunnon(val) {
    if(val) {
      $('.product-buttons button').prop('disabled', true);
    }
    if(!val) {
      $('.product-buttons button').prop('disabled', false);
    }
  }
  const $inputMain = $('#product-quantity-input');
  let pattern_1 = $('.pack_min_worning').text();
  let pattern_2 = $('.pack_closest_worning').text();
  $inputMain.on('input', function() {
    if( $('.shappify_qb_grid').length === 0 ) { return; }
    let currentAmount = 0;
    let minAmount = minBoldValue;
    let flag1 = true;
    let flag2 = true;
    if ( $(this).val() ) {
      currentAmount = parseInt($(this).val());
    }
    else {
      $(this).val(0);
      currentAmount = 0;
    }
    //Min Amount checker
    if(currentAmount < minAmount) {
      let txt = pattern_1.replace('{{X}}', currentAmount ).replace('{{Y}}', minAmount)
      $('.pack_min_worning').text(txt);
      $('.pack_min_worning').slideDown( "slow" );
      disableBunnon(true);
      flag1 = false;
    }
    else {
      $('.pack_min_worning').slideUp( "slow" );
      flag1 = true;
    }

    //if(currentAmount > minAmount && currentAmount !== 100 && currentAmount !== 5000) {
    if(currentAmount % minBoldValue !== 0 && currentAmount > minBoldValue) {
      var closest = currentAmount - (currentAmount % minBoldValue) + minBoldValue
      let txt = pattern_2.replace('{{X}}', currentAmount ).replace('{{Y}}', closest).replace('{{Y}}', minBoldValue);
      $('.pack_closest_worning').text(txt);
      $('.pack_closest_worning').slideDown( "slow" );
      disableBunnon(true);
      flag2 = false;
    }
    else {
      flag2 = true;
      $('.pack_closest_worning').slideUp( "slow" );
    }
    if( flag1 && flag2) {
        $('.pack_min_worning').slideUp( "slow" );
        $('.pack_closest_worning').slideUp( "slow" );
        disableBunnon(false);
    }
  })
})()*/
/* Handle max min amount JS END */

$('body').on('contextmenu', 'img', function(e) {
  return false;
});
$('.js-accordion-trigger').on('click', function() {
  const $this = $(this);
  $this.parent().toggleClass('is-active').siblings().removeClass('is-active');
  $this.next().slideToggle().parent().siblings().find('.accordion__body').slideUp();
});
const collectionsHtml = $('.js-collections-template').html();
$(window).on('load', function() {
  setTimeout(function() {
    if ($('.js-list-collections').hasClass('js-list-collections-hidden')) {
      $('.list-collections').addClass('is-hidden');
    }
  }, 500);
});
$(window).on('load', function() {
  setTimeout(function() {
    $('.list-collections ul').append(collectionsHtml);
  }, 1000);
});
$('.product-gallery--thumbnail-trigger').on('click', function() {
  $(this).addClass('thumbnail--selected').parent().siblings().find('.product-gallery--thumbnail-trigger').removeClass('thumbnail--selected');
});
$('.js-has-dropdown > a').on('click', function(event) {
  event.preventDefault();
  $(this).parent().find('.nav__dropdown-first').addClass('is-active');
});
$('.nav__dropdown-first__back').on('click', function(event) {
  event.preventDefault();
  $(this).parent().removeClass('is-active');
});
$('.js-has-dropdown-second > a').on('click', function(event) {
  event.preventDefault();
  const $this = $(this);
  $this.toggleClass('is-toggled');
  $this.next().slideToggle(400);
});
$('.form-field--checkbox input').on('click', function() {
  if($(this).prop('checked')) {
    $('.form-fields-columns--company').show();
  }
  else {
    $('.form-fields-columns--company').hide();
  }
});
if($('.form-field--checkbox input').prop('checked')) {
  $('.form-fields-columns--company').show();
}
else {
  $('.form-fields-columns--company').hide();
}
/* Disable quantity selector for BOLD items in cart */
window.addEventListener('load', function(){
  var cartItemsInputs = document.querySelectorAll('[data-line-index]');
  var waitForBold = setInterval(function() {
    if( typeof window.BOLD.csp !== 'undefined' ) {
      clearInterval( waitForBold );
      if(cartItemsInputs) {
        cartItemsInputs.forEach( function(el) {
          var val = parseInt(el.getAttribute('data-line-index'));
          if( BOLD.pre.getCartItemByLineIndex(val).discount ) {
            el.disabled = true;
          }
        })
      }
    }
  }, 100);
});